import { FORMS, ID_PROOFING_TYPE } from '../../ion/RemediationConstants.js';

function getIdvName(remediations) {
  let redirectIDVerifyRemediation = remediations.find(remediation => {
    return remediation.name === FORMS.REDIRECT_IDVERIFY;
  });
  return redirectIDVerifyRemediation.idp.name;
}
function getMetaInfoLinksForCustomIDV(remediations) {
  var _redirectIDVerifyReme, _redirectIDVerifyReme2;
  const redirectIDVerifyRemediation = remediations.find(r => r.name === FORMS.REDIRECT_IDVERIFY);
  return ((redirectIDVerifyRemediation === null || redirectIDVerifyRemediation === void 0 ? void 0 : (_redirectIDVerifyReme = redirectIDVerifyRemediation.idp) === null || _redirectIDVerifyReme === void 0 ? void 0 : _redirectIDVerifyReme.id) === ID_PROOFING_TYPE.IDV_STANDARD || (redirectIDVerifyRemediation === null || redirectIDVerifyRemediation === void 0 ? void 0 : (_redirectIDVerifyReme2 = redirectIDVerifyRemediation.idp) === null || _redirectIDVerifyReme2 === void 0 ? void 0 : _redirectIDVerifyReme2.id) === ID_PROOFING_TYPE.IDV_OIN) && (redirectIDVerifyRemediation === null || redirectIDVerifyRemediation === void 0 ? void 0 : redirectIDVerifyRemediation.idvMetadata) || undefined;
}
function getHelpLinks(remediations) {
  const idpName = getIdvName(remediations);
  let termsOfUse, privacyPolicy;
  switch (idpName === null || idpName === void 0 ? void 0 : idpName.toUpperCase()) {
    case 'PERSONA':
      termsOfUse = 'https://withpersona.com/legal/terms-of-use';
      privacyPolicy = 'https://withpersona.com/legal/privacy-policy';
      break;
    case 'CLEAR':
      termsOfUse = 'https://www.clearme.com/member-terms';
      privacyPolicy = 'https://www.clearme.com/privacy-policy';
      break;
    case 'INCODE':
      termsOfUse = 'https://incode.id/terms';
      privacyPolicy = 'https://incode.id/privacy';
      break;
    default:
      {
        const metaInfoLinks = getMetaInfoLinksForCustomIDV(remediations);
        termsOfUse = metaInfoLinks === null || metaInfoLinks === void 0 ? void 0 : metaInfoLinks.termsOfUse;
        privacyPolicy = metaInfoLinks === null || metaInfoLinks === void 0 ? void 0 : metaInfoLinks.privacyPolicy;
        break;
      }
  }
  return {
    termsOfUse: termsOfUse,
    privacyPolicy: privacyPolicy
  };
}

export { getHelpLinks, getIdvName, getMetaInfoLinksForCustomIDV };
//# sourceMappingURL=IdpUtil.js.map
